<div
  #container
  class="popup-container"
  [ngClass]="correct ? 'success' : 'danger'"
>
  <div class="header">
    <ion-icon [name]="correct ? 'checkmark' : 'close'"></ion-icon>
  </div>

  <div class="content">
    <h2>{{ title }}</h2>
    <p>{{ message }}</p>
    <ion-button shape="round" (click)="validated.emit(true)">
      {{ buttonLabel }}
    </ion-button>
  </div>
</div>
